import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import moment from 'moment';

import { Http } from '../../../../helpers/axois';
import style from './list.module.sass';
import classNames from 'classnames';

interface Props {
    currentDeploy: any
}


const History: React.FC<Props> = (props) => {

    const [count, setcount] = useState(0);
    const [list, setlist] = useState([]);
    const columns = [
        {
            title: 'Environment Name',
            dataIndex: 'env_name',
            key: 'vc',
            render: (text: any) => <span data-test-id="env_name">{text}</span>,
        },
        {
            title: 'Environment Type',
            dataIndex: 'env_type',
            key: 'entype',
            render: (text: any) => <div data-test-id="env_type" className={style.recDeployModal + " " + classNames({
                [style.depStatusStag]: (text === 'staging'),
                [style.depStatusTesting]: (text === 'testing'),
                [style.depStatusProd]: (text === 'production'),

            })}>{text.toUpperCase()}</div>,
        },
        {
            title: 'Deployed Time',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text: any) => {
                return <span data-test-id="deployed_time" >{moment.utc(text).fromNow()}</span>
            },
        }, {
            title: 'Deployed By',
            dataIndex: 'createdby',
            key: 'createdby',
            render: (text: any) => <span data-test-id="deployed_by">{text}</span>,
        }

    ]
    useEffect(() => {
        if (count === 0) {
            Http.get(`deployment/${props.currentDeploy.version_id}?appId=${props.currentDeploy.app_id}`).subscribe((res: any) => {
                setlist(res);
            })
            setcount(1);
        }
    }, [count, props])

    return (
        <React.Fragment>
            {list.length > 0 &&
                <Table
                    data-test-id="table"
                    rowKey="uid"
                    columns={columns}
                    className="override-table-container"
                    style={{ width: '100%' }}
                    dataSource={list}
                    pagination={false}
                />}

            {
                list.length === 0 && (<p>No data</p>)
            }
        </React.Fragment>
    )
}

export default History;